import React, { useState } from 'react';
import Head from 'next/head';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';
import { theme } from 'src/theme';
import { useRouter } from 'next/router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createI18nRestaurantAdmin } from 'i18n/i18n';

import type { ReactNode } from 'react';

type Props = {
    children?: ReactNode;
    title?: string;
};

const queryClient = new QueryClient();

const Layout = ({ children }: Props) => {
    const router = useRouter();
    useState(createI18nRestaurantAdmin);
    const { t } = useTranslation('qr');

    return (
        <>
            <Head>
                <title>{t('title')}</title>
                <link href={`${router.basePath}/favicon.ico`} rel="icon" />
                <link href={`${router.basePath}/logo192.png`} rel="apple-touch-icon" />
                <meta content="width=device-width, initial-scale=1, shrink-to-fit=no" name="viewport" />
                {
                    // At eslint package eslint-plugin-react version 7.31.7 is problem with keys global and jsx
                    //eslint-disable-next-line react/no-unknown-property
                    <style global jsx>{`
                        html,
                        body,
                        body > div:first-child,
                        div#__next,
                        div#__next > div {
                            height: 100%;
                            margin: 0;
                            minHeight: 100vh;
                            padding: 0;
                      }
                    `}
                    </style>
                }
            </Head>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider theme={theme}>
                    <SnackbarProvider>
                        <CssBaseline />
                        {children}
                    </SnackbarProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </>
    );
};

export default Layout;
